module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//loading_bg.jpg?v=423d72bf";